import { useT } from "@magic-md/i18n/react";
import { X } from "lucide-react";
import { cn } from "../lib/utils";
import { useEditorStore } from "../store/editor-store";

export function SidebarCloseButton({
    className,
    onClick,
}: {
    className?: string;
    onClick?: () => void;
}) {
    const t = useT("editor");
    const handleClick = onClick ?? (() => useEditorStore.setState({ sidebarOpen: false }));
    return (
        <button
            type="button"
            className={cn(
                "flex h-5 w-5 items-center justify-center rounded text-muted-foreground/50 transition-colors hover:bg-muted/60 hover:text-foreground",
                className,
            )}
            title={t("common.close")}
            aria-label={t("common.close")}
            onClick={handleClick}
        >
            <X size={12} />
        </button>
    );
}
